import * as React from "react";
import { Button, Grid, Message, Modal } from "semantic-ui-react";

import { format } from "date-fns";

import { CloneClinicResult } from "../models";

interface Props {
    cloneResults: CloneClinicResult[];
    onClose: () => void;
}

export const CloneClinicResultModal: React.FunctionComponent<Props> = ({ cloneResults, onClose }) => {

    return (
        <Modal open>
            <Modal.Header content="Clone Clinic Result" />
            <Modal.Content>
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={16}>
                            <Message>The clinic and any blocked time selected has been cloned to the following dates:</Message>
                        </Grid.Column>
                    </Grid.Row>
                    {cloneResults.map((r, index) => (
                        <Grid.Row key={index}>
                            <Grid.Column>{format(r.date, "dd/MM/yyyy")}</Grid.Column>
                        </Grid.Row>
                    ))}
                </Grid>
            </Modal.Content>
            <Modal.Actions>
                <Button content="Close" onClick={onClose} />
            </Modal.Actions>
        </Modal>
    );
};
